// extracted by mini-css-extract-plugin
export default {"wrap":"TextLose_wrap__H8AVn","title":"TextLose_title__h77fQ","subtitle":"TextLose_subtitle__Y2q29","body":"TextLose_body__fWOZb"};